import React from 'react';

type RenderableChild<TProps> = React.ReactNode | ((props: TProps) => React.ReactNode);

/**
 * Renders a child element by determining if it is a function or a static value
 * and returning the appropriate result based on the provided props.
 *
 * @param child - The child element to render. It can be either a function that accepts props or a static value.
 * @param props - The props to pass to the child element if it is a function.
 * @return The rendered child, either the result of the function with the given props or the static child itself.
 */
export function renderChild<TProps>(child: RenderableChild<TProps>, props: TProps) {
  return typeof child === 'function' ? child(props) : child;
}
